export const Brand_GoogleMeet = `<svg title="Brand_GoogleMeet" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path d="M13.5926 13.4636C12.8166 12.9275 12.8061 11.7843 13.5723 11.2341L19.8409 6.73216C20.7432 6.08432 22 6.72784 22 7.83864V16.6744C22 17.7739 20.7658 18.4198 19.8613 17.7948L13.5926 13.4636Z" fill="url(#paint0_linear_3725_1861)"/>
<path d="M2 9.15909C2 6.39773 4.23864 4.15909 7 4.15909H14.2727C15.528 4.15909 16.5455 5.17659 16.5455 6.43182V17.5682C16.5455 18.8234 15.528 19.8409 14.2727 19.8409H4.27273C3.0175 19.8409 2 18.8234 2 17.5682V9.15909Z" fill="url(#paint1_radial_3725_1861)"/>
<mask id="mask0_3725_1861" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="4" width="15" height="16">
<path d="M2 9.15909C2 6.39773 4.23864 4.15909 7 4.15909H14.2727C15.528 4.15909 16.5455 5.17659 16.5455 6.43182V17.5682C16.5455 18.8234 15.528 19.8409 14.2727 19.8409H4.27273C3.0175 19.8409 2 18.8234 2 17.5682V9.15909Z" fill="white"/>
</mask>
<g mask="url(#mask0_3725_1861)">
<g filter="url(#filter0_f_3725_1861)">
<path d="M8.49283 12.3743L21.9893 4.62016V19.8344L8.49283 12.3743Z" fill="url(#paint2_linear_3725_1861)"/>
</g>
</g>
<path d="M5.40909 18.0227C6.28772 18.0227 6.99999 17.3105 6.99999 16.4318C6.99999 15.5532 6.28772 14.8409 5.40909 14.8409C4.53045 14.8409 3.81818 15.5532 3.81818 16.4318C3.81818 17.3105 4.53045 18.0227 5.40909 18.0227Z" fill="white"/>
<defs>
<filter id="filter0_f_3725_1861" x="4.49283" y="0.620162" width="21.4965" height="23.2142" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_3725_1861"/>
</filter>
<linearGradient id="paint0_linear_3725_1861" x1="15.7273" y1="12.2564" x2="26.9091" y2="12.2564" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6A100"/>
<stop offset="1" stop-color="#FFBE00"/>
</linearGradient>
<radialGradient id="paint1_radial_3725_1861" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(19.3128 12.006) rotate(180) scale(18.1506 15.4377)">
<stop offset="0.15" stop-color="#FFE921"/>
<stop offset="1" stop-color="#FEC700"/>
</radialGradient>
<linearGradient id="paint2_linear_3725_1861" x1="16.1365" y1="12.2166" x2="9.05453" y2="12.2007" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFB5E8"/>
<stop offset="1" stop-color="#FFDBF5" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>`;